import { RolesTypes } from './actionTypes';

const INIT_STATE = {
  roles: [],
  rolesDetail: {},
  rolesAdd: {},
  CountItems: 0,
  deleteId: undefined,
  rolesUpdate: '',
  error: '',
  success: '',
  isLoading: false,
};

const Roles = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case RolesTypes.GET_ROLES:
      return {
        ...state,
        isLoading: true,
      };
    case RolesTypes.GET_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.payload.rolesData,
        CountItems: action.payload.CountItems,
        rolesAdd: {},
        isLoading: false,
      };
    case RolesTypes.GET_ROLES_FAIL:
      return {
        ...state,
        error: action.payload,
        roles: [],
        rolesAdd: {},
        isLoading: false,
      };
    case RolesTypes.GET_ROLES_DETAIL_SUCCESS:
      return {
        ...state,
        rolesDetail: action.payload,
      };

    case RolesTypes.GET_ROLES_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case RolesTypes.ADD_ROLES:
      return {
        ...state,
        isLoading: true,
      };
    case RolesTypes.ADD_ROLES_SUCCESS:
      return {
        ...state,
        rolesAdd: action.payload,
      };
    case RolesTypes.ADD_ROLES_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case RolesTypes.DELETE_ROLES:
      return {
        ...state,
        isLoading: true,
      };
    case RolesTypes.DELETE_ROLES_SUCCESS:
      return {
        ...state,
        deleteId: action.payload,
      };
    case RolesTypes.DELETE_ROLES_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case RolesTypes.UPDATE_ROLES:
      return {
        ...state,
        isLoading: true,
      };

    case RolesTypes.UPDATE_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.payload.rolesData,
        rolesUpdate: true,
        error: '',
        isLoading: false,
      };
    case RolesTypes.UPDATE_ROLES_FAIL:
      return {
        ...state,
        error: action.payload,
        rolesUpdate: false,
        isLoading: false,
      };

    default:
      break;
  }
  return state;
};

export default Roles;
